<template>
    <div>
        The AUC of the combination DRC is:
        <br><br> <vue-mathjax :formula="formula.combo_auc"></vue-mathjax><br><br>
        And the Bliss AUC is:
        <br><br><vue-mathjax :formula="formula.bliss_auc"></vue-mathjax><br><br>
        where <span class="math-inline"><vue-mathjax :formula="'$$n$$'"></vue-mathjax></span>  is the total number of doses and  <span class="math-inline"><vue-mathjax :formula="'$$s_i$$'"></vue-mathjax></span> is the synergy score for the <span class="math-inline"><vue-mathjax :formula="'$$i_{th}$$'"></vue-mathjax></span> dose.
    </div>
  </template>
<script>
export default {
    name: "DrcComboDetails",
    data: () => ({
        formula: {
            bliss_auc: "$$Riemann-SumsAUC_{bliss}\\approx \\frac{1}{n}\\sum_{i=1}^nFC_{a_i}FC_b$$",
            combo_auc: "$$Riemann-SumsAUC_{combo} \\approx\\frac{1}{n}\\sum_{i=1}^nFC_{c_i}$$",
        }
    }),
    mounted(){

    },
    computed:{

    }
}
</script>
<style scoped>
.math-block {
  margin: 16px 0px;
  display:block; 

}
.math-inline{
  width:auto;
  display:inline-block;
}

</style>